export const parameterCacheKey = 'DeviceReplaceApplyFormCacheKey'
export const brandCacheKey = 'DeviceReplaceBrandCacheKey'
export const userDeviceCacheKey = 'DeviceReplaceUserDeviceCacheKey'
export const cacheTagListKey = 'DeviceReplaceActivityTagCacheKey'
export const cacheActivityListKey = 'DeviceReplaceActivityListCacheKey'
export const activityStart = '2023/4/20 10:00:00' // 四期活动开始时间
export const activityEnd = '2023/5/31 10:00:00' // 四期活动结束时间

export const deviceTypeOptions = [
  {
    label: '拥有极飞设备',
    value: '1',
  },
  {
    label: '其他品牌设备',
    value: '0',
  },
]
export const modelTypeOptions = [
  // {
  //   label: '无人机',
  //   value: '1',
  // },
  {
    label: '自驾仪',
    value: '2',
  },
]
// 1-待网点受理 2-待网点检测设备 3-待用户支付 4-待网点发货 5-待用户确认收货 6-交易成功 7-交易取消 11-待支付定金
export const statusColorMap = new Map([
  ['1', '#F7981C'],
  ['2', '#F7981C'],
  ['3', '#F7981C'],
  ['4', '#F7981C'],
  ['5', '#F7981C'],
  ['6', '#39B54A'],
  ['7', 'rgba(0, 0, 0, 0.44)'],
  ['11', '#F7981C'],
])
//11-定金待支付 12-定金已付款 21-尾款待支付 22-尾款已支付
export const payStatusTextMap = new Map([
  ['11', '待支付定金'],
  ['12', '待支付尾款'],
  ['21', '待支付尾款'],
  ['22', '尾款已支付'],
])

export const reasonList = ['不喜欢/不想要', '发货问题', '已通过其他途径购买', '其他']

export const filterOptions = [
  {
    label: '选择版本',
    type: 'version',
    items: [
      {
        value: '标准',
        label: '标准版',
      },
      {
        value: '轻简',
        label: '轻简版',
      },
      {
        value: '载机+睿喷',
        label: '飞行平台 (载机+睿喷)',
      },
    ],
  },
  {
    label: '选择充电方式',
    type: 'charge',
    items: [
      {
        value: '燃油',
        label: '燃油充电',
      },
      {
        value: '市电',
        label: '市电充电',
      },
    ],
  },
  {
    label: '选择遥控方式',
    type: 'control',
    items: [
      {
        value: '单手',
        label: '单手遥控',
      },
      {
        value: '双手',
        label: '双手遥控',
      },
    ],
  },
]
